<template lang="pug">
	.ssml--eleven-labs-settings.flex-col.space
		.flex-col
			.flex-row.justify
				.grey.upper.small-font {{$tCaption('Stability')}}  {{$Data.formatNumber(settings.Stability, '#0.0#')}}
				.helper
					fas(icon="circle-question", id="stabilityHelp")
					DxTooltip(target="#stabilityHelp", show-event="dxhoverstart", hide-event="dxhoverend", width="400")
						pre.pre-wrap.ssml--eleven-labs-settings.tooltip-content {{stabilityDesc}}
			DxSlider(:value.sync="settings.Stability", :min="0", :max="1", :show-spin-buttons="true", :step="0.01", :show-range="false")
		.flex-col
			.flex-row.justify
				.grey.upper.small-font {{$tCaption('Similarity')}}  {{$Data.formatNumber(settings.Similarity, '#0.0#')}}
				.helper
					fas(icon="circle-question", id="similarityHelp")
					DxTooltip(target="#similarityHelp", show-event="dxhoverstart", hide-event="dxhoverend", width="400")
						pre.pre-wrap.ssml--eleven-labs-settings.tooltip-content {{similarityDesc}}
			DxSlider(:value.sync="settings.Similarity", :min="0", :max="1", :show-spin-buttons="true", :step="0.01", :show-range="false")
		.flex-col
			.flex-row.justify
				.grey.upper.small-font {{$tCaption('Style')}}  {{$Data.formatNumber(settings.Style, '#0.0#')}}
				.helper
					fas(icon="circle-question", id="styleHelp")
					DxTooltip(target="#styleHelp", show-event="dxhoverstart", hide-event="dxhoverend", width="400")
						pre.pre-wrap.ssml--eleven-labs-settings.tooltip-content {{styleDesc}}
			DxSlider(:value.sync="settings.Style", :min="0", :max="1", :show-spin-buttons="true", :step="0.01", :show-range="false")
		.flex-col
			.flex-row.justify.align-center
				DxCheckBox(:value.sync="settings.UseSpeakerBoost", :text="$tCaption('Speaker boost')")
				.helper
					fas(icon="circle-question", id="speakerBoostHelp")
					DxTooltip(target="#speakerBoostHelp", show-event="dxhoverstart", hide-event="dxhoverend", width="400")
						pre.pre-wrap.ssml--eleven-labs-settings.tooltip-content {{speakerBoostDesc}}
			
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxSlider from 'devextreme-vue/slider';
	import DxCheckBox from 'devextreme-vue/check-box';
	import { DxTooltip } from 'devextreme-vue/tooltip';

	export default {
		translationCategory: 'insertion.SSMLElevenLabsSettings',
		name: 'ssml--eleven-labs-settings',
		components: { DxButton,  DxSlider, DxCheckBox, DxTooltip },
		props: ['record'],
		data() {
			
			return {
				stabilityDesc: this.$tCaption(`The stability slider determines how stable the voice is and the randomness between each generation. Lowering this slider introduces a broader emotional range for the voice. As mentioned before, this is also influenced heavily by the original voice. Setting the slider too low may result in odd performances that are overly random and cause the character to speak too quickly. On the other hand, setting it too high can lead to a monotonous voice with limited emotion.`),
				similarityDesc: this.$tCaption(`The similarity slider dictates how closely the AI should adhere to the original voice when attempting to replicate it. If the original audio is of poor quality and the similarity slider is set too high, the AI may reproduce artifacts or background noise when trying to mimic the voice if those were present in the original recording.`),
				styleDesc: this.$tCaption(`With the introduction of the newer models, we also added a style exaggeration setting. This setting attempts to amplify the style of the original speaker. It does consume additional computational resources and might increase latency if set to anything other than 0. It’s important to note that using this setting has shown to make the model slightly less stable, as it strives to emphasize and imitate the style of the original voice.\n\nIn general, we recommend keeping this setting at 0 at all times.`),
				speakerBoostDesc: this.$tCaption('This is another setting that was introduced in the new models. The setting itself is quite self-explanatory – it boosts the similarity to the original speaker. However, using this setting requires a slightly higher computational load, which in turn increases latency. The differences introduced by this setting are generally rather subtle.')
			};
		},
		computed: {
			settings() {
				return this.record.voiceSettings || {};
			}
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.elevelLabsSettings = this;

			this.init();
		},
		methods: {
			init() {
				if (!this.record.voiceSettings || this.record.voiceSettings?.TtsProviderType !== 2) {
					this.$set(this.record, 'voiceSettings', {
						...(this.record.voiceSettings || {}),
						Stability: 0.9,
						Similarity: 0,
						Style: 0,
						UseSpeakerBoost: false
					});
				}
			}
		}
	};
</script>
<style lang='scss'>
	.ssml--eleven-labs-settings {
		&.tooltip-content {
			text-align: left;
		}

		.helper {
			color: #c1c1c1;
		}
	}
</style>
